<template>
    <v-card class="px-5 px-md-13 px-sm-7 px-lg-16 py-5 py-md-8 py-sm-5 py-lg-10" >
      <v-card-text>
          <p v-text="$t('RevokePage.mail_authenticate')" class="text-center mb-0"></p>
        <v-row justify="center">
          <v-col cols="12" sm="5" md="5">
            <v-otp-input
              v-model="input_otp" @finish="focusSubmit" 
              :label="$t('Authenticate.EnterCode')"
              type="number"
            ></v-otp-input>
          </v-col>
        </v-row>
      </v-card-text>
      <v-row justify="center">
        <v-col cols="12" class="text-right">
          <custom-button id="submit"
            :text="$t('Navigation.next')"
            @click="checkOTP"
          ></custom-button>
        </v-col>
      </v-row>
    </v-card>
</template>

<script>
import CustomButton from "../../components/ui/input/CustomButton.vue";

import { log } from "@/helpers/logger";

export default {
  name: "mail",
  components: {
    CustomButton,
  },
  props: ["otp"],
  data() {
    return {
      input_otp: "",
    };
  },
  methods: {
    focusSubmit() {
      document.getElementById("submit").focus();
    }, 
    async checkOTP() {
      this.$store
        .dispatch("data/checkOTP", {
          otp: this.otp,
          input_otp: this.input_otp,
        })
        .then((resp) => {
          log("RevokePage.Authorize.checkOTP() - checked mail OTP", "info");
          if (resp) {
            this.$emit("next", true);
          }
        })
        .catch((err) => {
          this.otp = "";
          log("RevokePage.Authorize.checkOTP() - " + err, "error");
        });
    },
  },
};
</script>
